module.exports = __webpack_public_path__ + "img/retriggerassessmentdisabled.b95f8e9d.svg";